<template>
<div>

  <!-- Modal MESSAGE -->  
  <modalMessage ref="msgModal"/>

  <div class="table-responsive-sm mt-1">
  <table class="table table-bordered table-sm my-table">
     <caption>Tabella prezzo,sconto per etichetta promo</caption>

    <thead class="thead-light sticky-col">
      
     
      <tr>

      <th class="text-center" :colspan="cols.length + 1" >                           
        PREZZO E SCONTO ETICHETTA PROMO
      </th>             
      </tr>

      <tr>
        <th class="text-center "></th>        
        <th  v-for="(col, index) in cols"
            :key="'size-'+ index"
            class="text-center sizes"
            >
          {{ col.size }}
        </th>
      </tr>

    </thead>

    <tbody>
        <tr>
        
        </tr>

        <tr>

         <td class="text-center">PREZZO €</td> 
            <td v-for="(_, cIndex) in cols" :key="cIndex">
              <input :ref="cIndex === 0 ? 'firstInput' : null" @input="setPrice($event.target.value,cIndex)" required type="number" min="0" step="0.00"
                    class="form-control form-control-sm inputClass sticky-col"
                    v-model="prices[cIndex].price"
                    >
            </td>        
        </tr>

      <tr >

         <td class="text-center">SCONTO %</td> 
         <td v-for="(_, cIndex) in cols" :key="cIndex">
          <input @input="setDiscount($event.target.value,cIndex)" required type="number" min="0" step="0.00"
                 class="form-control form-control-sm inputClass sticky-col"                 
                 v-model="discounts[cIndex].discount"
                 
                 >
        </td>        
      </tr>
  </tbody>
   

    
  </table>

 </div>

 <button @click="updateData()"
              type="button"
              class="btn btn-primary ">
          MODIFICA
      </button>

    
  <div v-if="false">
      <h5 class="mb-4">Dati JSON TABLE:</h5>
      <pre>{{ rows }} </pre> 
      
  </div>


</div> 
</template>

<script>

import { mapGetters }       from 'vuex';
import api                  from '@/api' 
import modalMessage                from '@/components/modalDialog/ModalMessage.vue'         
export default {
  
  components: {modalMessage},  
  props: ['item'],
  
  data () {
  
    return {
    
     items         : [], 
     cols          : [],
     rows          : [],
   
     productSizes  : [],
     allSizes      : [],

     prices        : [],
     discounts     : []
    
     
     

    }
  },
 
  computed:
  {
    ...mapGetters(['company']),

    
  
  },
  
 

   directives: 
    {
      

    },
  async mounted()
    {   
        const data        = await this.getData()
        this.cols         = data.sizes
        this.prices       = data.prices
        this.discounts    = data.discounts
      
        this.$nextTick(() => {
      const refName = 'firstInput' 
      const ref = this.$refs[refName];            
      const input = Array.isArray(ref) ? ref[0] : ref;
      
        if (input && input.focus) input.focus();

    })  


    },
  async created()
  {
  
    

 
    

  },

  methods: 
  {

     




    async getData()
    {
        
        
        this.$refs.msgModal.setSpinner(true)  
        const sp       = 'spProductCustomLabel'
        const payload  = {'productId'       : this.item.productId,
                          
                          sp
                        }                
        try{
        
          const res = await api.post(payload)
          if (res.status !== 200) 
          {
            throw new Error(res.data ||  res)
          }

          this.$refs.msgModal.close()               
          return res.data.recordsets[0][0]
                                              
        }catch(err){

            this.$refs.msgModal.show(err) 
            return []
        }
        
        
      },


async updateData()
    {
        
        
        this.$refs.msgModal.setSpinner(true)  
        const sp       = 'spUpdateProductCustomLabel'
        const labels   = [this.prices,this.discounts]
        const payload  = {'productId'       : this.item.productId,
                          labels,
                          sp
                        }        
        
        
        
        try{
        
          const res = await api.post(payload)
          if (res.status !== 200) 
          {
            throw new Error(res.data ||  res)
          }

            this.$refs.msgModal.close()               
            await this.$refs.msgModal.show('MODIFICA EFFETTUATA.',{title:'MESSAGGIO'},4)               
            this.$emit('update')    
               

                
        }catch(err){

            this.$refs.msgModal.show(err) 
            
        }
        
        
      },


  
      setPrice(value,index) {
       
        for (let i = index + 1; i < this.cols.length; i++) 
        {
          this.prices[i].price = value;
        }      
      
      },
      setDiscount(value,index) {
          // Per ogni colonna dinamica (escludendo la prima)
          
        for (let i = index + 1; i < this.cols.length; i++) {
          this.discounts[i].discount = value;
        }      
      },
  

  }
  
}
</script>

<style scoped>

.inputClass{
  font-weight       : bold;
}

h4 {
  font-family  : 'Roboto Condensed';
  font-size    : 14px;
}
.pointer{
  cursor: pointer;
}
thead th.sticky-col {
  z-index          : 20;
  background       : #28a745;
  color            : white;
  border-color     : white !important;
  border-top       : 2px solid #28a745 !important; 
  border-bottom    : 2px solid #28a745 !important;
  
  padding-top       : 6px; /* distanza dal bordo superiore */ 
  padding-bottom    : 6px; /* distanza dal bordo inferiore */ 
  padding-left      : 8px; /* opzionale */ 
  padding-right     : 8px; /* opzionale */
  

}

thead th.sticky-col1 {
  z-index       : 20;
  background    : #969898;
  color         : black;
  border-color  : white !important;
  border-top    : 2px solid #a5aca7 !important; 
  border-bottom : 2px solid #b2bab4 !important;
  


}

.sizes {
  position    : sticky;
  background  : #5c8fb1 !important;
  color       : white !important ;
  z-index     : 10;
}


.my-table,
.my-table th, 
.my-table td
{
  border-color: #28a745 !important;
}





</style>